import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  toggle(event) {
    const checkbox = event.target
    const url = checkbox.dataset.contentFollowerUrl

    fetch(url, {
      method: 'PUT',
      headers: {
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        following: checkbox.checked
      })
    })
      .then(response => {
        if (!response.ok) {
          checkbox.checked = !checkbox.checked // revert on failure
          throw new Error('Network response was not ok')
        }
      })
      .catch(error => {
        console.error('Error:', error)
      // You might want to add some user feedback here
      })
  }
} 
